import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';

import { appSettings } from './app-settings';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

  private readonly configUrl = 'config/';

  constructor(private readonly http: HttpClient) { }

  getSettings(): Promise<any> {
    return this.http.get<any>(this.configUrl)
      .toPromise()
      .then(settings => {
        if (isDevMode()) {
          console.log(`Settings from API: `, settings);
        }

        Object.assign(appSettings, settings);
      });
  }

}
